/* src/js/layoutPro.js */

jQuery( document ).ready(function( $ ) {


    enquire.register("screen and (max-width:636px)", {

        // OPTIONAL
        // If supplied, triggered when a media query matches.
        match: function () {
            console.log('test is matched');



            $('#js-star-move').remove().clone().insertAfter('#js-star-target');



            $('#js-move-target2').remove().clone().insertAfter('.profileBox-big .profileBox-big__inner');



        },

        unmatch: function () {
            console.log('636px is un-matched');




            $('#js-star-move').remove().clone().appendTo('.profileBox-big .profileBox__imgWrap');




            $('#js-move-target2').remove().clone().appendTo('.btnStack');





        },

        // OPTIONAL
        // If supplied, triggered once, when the handler is registered.
        setup: function () {
        },

        // OPTIONAL, defaults to false
        // If set to true, defers execution of the setup function
        // until the first time the media query is matched
        deferSetup: true,

        // OPTIONAL
        // If supplied, triggered when handler is unregistered.
        // Place cleanup code here
        destroy: function () {
        }

    });

});